// параметры которые не влияют на филтры
const draftQueries = ['query', 'page', 'precise', 'limit', 'noTerm', 'sort'];

function getFiltersFromURL(URL) {
    const filters = {};

    // получаем фильтры из адресной строки
    for (let param in URL) {
        if (!draftQueries.find((item) => item == param)) {
            typeof URL[param] === 'string'
                ? filters[param] = [URL[param]]
                : filters[param] = URL[param];
        }
    }

    return filters;
}

function getModificationFilters(filters, filtersFromURL, setCheck = false) {
    for (let key in filters) {
        filters[key].show = false;
        filters[key].type = key;
        filters[key].query = '';

        if (!filters[key].items.length) continue;

        for (let i = 0; i < filters[key].items.length; i++) {
            // добавляем новое поле в объект для хранения состояния
            if (setCheck) {
                if (!Object.keys(filtersFromURL).length) {
                    filters[key].items.forEach((item) => item.choose = false);
                } else {
                    filters[key].items[i].choose =
                    !!filtersFromURL?.[key]?.find((item) => item === filters[key].items[i].value);
                }
            } else {
                filters[key].items[i] = {
                    id: i,
                    show: true,
                    value: filters[key].items[i],
                    choose: !!filtersFromURL?.[key]?.find((item) => {
                        return item === filters[key].items[i];
                    }),
                };
            }

            filters[key].items.find(item => item.choose)
                ? filters[key].items.sort((a, b) => +b.choose - +a.choose)
                : filters[key].items.sort((a, b) => a.id - b.id);
        }
    }

    return filters;
}

function resetlAllFilters(query) {
    
    for(const [key, filter] of Object.entries(query)) {
        if (!draftQueries.find((item) => item == key))
            delete query[key];
    };
    
    return query;
};

export {
    resetlAllFilters,
    getFiltersFromURL,
    getModificationFilters,
};